const headers = [
  {
    text: 'loading.loading_loading-date',
    value: 'loadingDate',
    width: '100px'
  },
  {
    text: 'loading.loading_loading-storage',
    value: 'storage.name',
    width: '80px'
  },
  {
    text: 'loading.loading_loading-user',
    value: 'userId',
    width: '80px'
  },
  {
    text: 'common.input_supplier-name',
    value: 'order.supplierId',
    width: '210px'
  }
]

const tableKey = 'loadingId'

const productListHeaders = [
  {
    text: 'common.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '26%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'loading.loading_loading-quantity-lot-number',
    value: 'quantityAndStorageNo',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end'
  },
  {
    text: 'loading.loading_lot-number',
    value: 'productLotNumber',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'loading.loading_expiration-date',
    value: 'productExpiredDate',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

export default { headers, tableKey, productListHeaders }
